export const directoryResults = {
  query: 'ahmed',
  total: 24,
  items: Array.from({ length: 12 }, (_, i) => ({
    id: `dir-${i}`,
    kind: 'person',
    displayName: `Ahmed Al-${i + 1}`,
    email: `ahmed.al${i}@partner.example`,
    department: ['Sales', 'Engineering'][i % 2],
    role: 'Member',
    source: i % 2 === 0 ? 'graph' : 'manual',
    sourceSystems: i % 2 === 0 ? ['M365'] : ['M365', 'Google'],
    aliases: [`a.al${i}@acme.example`],
    lastMeetingAt: new Date(Date.now() - i * 86400000).toISOString(),
    recentMeetings: ['Q1 Review', 'Vendor sync', 'Weekly standup'].slice(0, 3),
  })),
};

export const directoryGroupsSeed = Array.from({ length: 6 }, (_, i) => ({
  id: `grp-${i}`,
  kind: 'group',
  displayName: `Project Falcon ${i + 1}`,
  provider: i % 2 === 0 ? 'M365' : 'Google',
  memberCount: 8 + i * 3,
  email: `falcon${i}@groups.acme.example`,
}));

export const directoryExternalsSeed = Array.from({ length: 5 }, (_, i) => ({
  id: `ext-${i}`,
  kind: 'external',
  displayName: `External ${i + 1}`,
  email: `guest${i}@vendor.example`,
  addedBy: 'Sara Al Hinai',
  lastMeetingAt: new Date(Date.now() - i * 172800000).toISOString(),
}));

export const aliasList = Array.from({ length: 16 }, (_, i) => ({
  id: `alias-${i}`,
  alias: `alias${i}@legacy.example`,
  resolvedUser: i % 11 === 0 ? null : `User ${i % 8}`,
  resolvedUserId: i % 11 === 0 ? null : `usr-${2100 + (i % 8)}`,
  resolvedUsers: i % 11 === 0 ? [`usr-2101`, `usr-2102`] : null,
  source: i % 4 === 0 ? 'AI Suggestion' : 'Manual',
  confidence: i % 4 === 0 ? 87 : 100,
  status: i % 11 === 0 ? 'conflict' : i % 6 === 0 ? 'pending' : 'approved',
}));

export const groupMappings = Array.from({ length: 10 }, (_, i) => ({
  id: `gm-${i}`,
  groupName: `Project Team ${i + 1}`,
  provider: i % 2 === 0 ? 'M365' : 'Google',
  memberCount: 5 + i * 2,
  autoExpand: i % 3 === 0,
  lastSync: new Date(Date.now() - i * 7200000).toISOString(),
  linkedDepartmentId: `dept-${i % 8}`,
  excludeRolePattern: i % 5 === 0 ? 'intern' : '',
  excludeUserIds: [],
  members: Array.from({ length: Math.min(24, 6 + i) }, (_, j) => ({
    id: `m-${i}-${j}`,
    name: `Member ${j + 1}`,
    email: `m${j}@acme.example`,
    includeAutoExpand: true,
  })),
}));
